var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaitingList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.90575 0.818182C5.52125 0.296979 6.41384 0 7.36364 0C8.31343 0 9.20602 0.296979 9.82152 0.818182H10.6364C11.5401 0.818182 12.2727 1.55081 12.2727 2.45455H13.0909C13.9946 2.45455 14.7273 3.18717 14.7273 4.09091V16.3636C14.7273 17.2674 13.9946 18 13.0909 18H1.63636C0.732625 18 0 17.2674 0 16.3636V4.09091C0 3.18717 0.732625 2.45455 1.63636 2.45455H2.45455C2.45455 1.55081 3.18717 0.818182 4.09091 0.818182H4.90575ZM10.6364 4.90909C11.242 4.90909 11.7709 4.58002 12.0538 4.09091H13.0909V16.3636H1.63636V4.09091H2.67346C2.9564 4.58002 3.48522 4.90909 4.09091 4.90909H10.6364ZM5.61078 2.45455L5.85544 2.17258C6.12425 1.86279 6.70043 1.63636 7.36364 1.63636C8.02684 1.63636 8.60302 1.86279 8.87183 2.17258L9.11649 2.45455H10.6364V3.27273H4.09091V2.45455H5.23747H5.61078Z",
    fill: "#607783"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaitingList);
export default __webpack_public_path__ + "static/media/waitingList.e9c990db09b3b6c1ca146c7339dc92d3.svg";
export { ForwardRef as ReactComponent };